import { createBrowserRouter, Navigate } from 'react-router-dom';

import OakyaStudentForm from '../pages/OakyaStudentForm';
import OakyaStudentReport from '../pages/OakyaStudentReport';

const router = createBrowserRouter([
    
       {
  path: '/',
  element: <OakyaStudentForm/>
},
{path:'/std-reports',element:<OakyaStudentReport/>}
    
    
]);

export default router;
